import React from 'react';
import PropTypes from 'prop-types';
import {Button, TextStyle, Stack, Subheading} from '@shopify/polaris';
import {KeyCodes} from 'global-constants';

export default class FileItem extends React.Component {
  constructor(props) {
    super(props);

    this.objectURL = window.URL.createObjectURL(props.fileObj.file);
    this.handleOnKeyPress = this.handleOnKeyPress.bind(this);
    this.handleOnClick = this.handleOnClick.bind(this);
  }

  handleOnKeyPress({keyCode}) {
    if (keyCode === KeyCodes.enter) {
      this.props.onRemove(this.props.fileObj);
    }
  }

  handleOnClick() {
    this.props.onRemove(this.props.inputId, this.props.fileObj);
  }

  componentWillUnmount() {
    window.URL.revokeObjectURL(this.objectURL);
  }

  render() {
    const {file} = this.props.fileObj;

    return (
      <Stack alignment="center">
        <Stack.Item fill>
          <Subheading>
            <TextStyle variation="strong">{file.name}</TextStyle>
          </Subheading>
        </Stack.Item>
        <Stack.Item>
          <Button
            plain
            onKeyPress={this.handleOnKeyPress}
            onClick={this.handleOnClick}
          >
            Remove File
          </Button>
        </Stack.Item>
      </Stack>
    );
  }
}

FileItem.propTypes = {
  inputId: PropTypes.string.isRequired,
  fileObj: PropTypes.shape({
    file: PropTypes.shape({
      name: PropTypes.string,
    }),
    signedId: PropTypes.string,
  }).isRequired,
  onRemove: PropTypes.func.isRequired,
};
